import React from "react";
import { Link } from "react-router-dom";
import CompanyMenu from "./companyMenu";
import SupplierMenu from "./SupplierMenu";
import InvestorsMenu from "./InvestorsMenu";
import { Slang } from "../../../helpers";
import { useSelector } from "react-redux";

const Index = () => {
  const menu = Slang("dashboard.menu");
  const menu1 = Slang("dashboard.menu.m1");
  const menu3 = Slang("dashboard.menu.m3");
  const menu4 = Slang("dashboard.menu.m4");
  const menu5 = Slang("dashboard.menu.m5");
  const menu7 = Slang("dashboard.menu.m7");
  const menu8 = Slang("dashboard.menu.m8");

  const menu35 = Slang("dashboard.menu.m3.m35");

  const { name : userType } = useSelector((state) => state.auth.user.roles[0]);

  return (
    <ul
      id="navbarSettings"
      className="navbar-nav nav nav-vertical nav-tabs nav-tabs-borderless nav-sm"
    >
      <li className="nav-item">
        <span className="nav-subtitle">{menu("title")}</span>
      </li>
      <li className="nav-item ">
        <a
          className="nav-link dropdown-toggle"
          href="#dashboardSidebar"
          role="button"
          data-bs-toggle="collapse"
          aria-expanded="false"
          aria-controls="dashboardSidebar"
        >
          {menu1("title")}
        </a>

        <div id="dashboardSidebar" className="nav-collapse collapse ">
          <a
            className="nav-link dropdown-toggle"
            href="#recentActivities"
            role="button"
            data-bs-toggle="collapse"
            aria-expanded="false"
            aria-controls="recentActivities"
          >
            {menu1("m11.title")}
          </a>

          <div id="recentActivities" className="nav-collapse collapse ">
            <Link className="nav-link" to="/dashboard/company">
              {menu1("m11.m111")}
            </Link>
            <Link className="nav-link" to="/dashboard/company">
              {menu1("m11.m112")}
            </Link>
            <Link className="nav-link" to="/dashboard/company">
              {menu1("m11.m113")}
            </Link>
          </div>
        </div>
        <CompanyMenu />
        <SupplierMenu />
        <InvestorsMenu />
        <div id="dashboardSidebar" className="nav-collapse collapse ">
          <a
            className="nav-link dropdown-toggle"
            href="#opportunity"
            role="button"
            data-bs-toggle="collapse"
            aria-expanded="false"
            aria-controls="opportunity"
          >
            Opportunités à Ne Pas Manquer
          </a>

          <div id="opportunity" className="nav-collapse collapse ">
            <Link className="nav-link" to="/dashboard/company">
              Partenariats proposés
            </Link>
            <Link className="nav-link" to="/dashboard/company">
              Appels d'offres
            </Link>
            <Link className="nav-link" to="/dashboard/company">
              Projets de financement
            </Link>
          </div>
        </div>
      </li>
      <li className="nav-item ">
        <Link to="/dashboard/profile" className="nav-link">
          {menu("m2")}
        </Link>
      </li>
      {userType !== "client" && (
        <>
          <li className="nav-item ">
            <a
              className="nav-link dropdown-toggle"
              href="#provider"
              role="button"
              data-bs-toggle="collapse"
              aria-expanded="false"
              aria-controls="provider"
            >
              {menu3("title")}
            </a>

            <div id="provider" className="nav-collapse collapse ">
              <Link className="nav-link" to="/dashboard/company">
                {menu3("m31")}
              </Link>
              <Link className="nav-link" to="/dashboard/company">
                {menu3("m32")}
              </Link>
              <Link className="nav-link" to="/dashboard/company">
                {menu3("m33")}
              </Link>
              <Link className="nav-link" to="/dashboard/company">
                {menu3("m34")}
              </Link>
            </div>

            <div id="provider" className="nav-collapse collapse ">
              <a
                className="nav-link dropdown-toggle"
                href="#providerManagement"
                role="button"
                data-bs-toggle="collapse"
                aria-expanded="false"
                aria-controls="providerManagement"
              >
                {menu35("title")}
              </a>

              <div id="providerManagement" className="nav-collapse collapse ">
                <Link className="nav-link" to="/product_managment/add">
                  {menu35("m351")}
                </Link>
                <Link className="nav-link" to="/product_managment/list">
                  {menu35("m352")}
                </Link>
              </div>
            </div>
          </li>
          <li className="nav-item ">
            <a
              className="nav-link dropdown-toggle"
              href="#partnership"
              role="button"
              data-bs-toggle="collapse"
              aria-expanded="false"
              aria-controls="partnership"
            >
              {menu4("title")}
            </a>

            <div id="partnership" className="nav-collapse collapse ">
              <a
                className="nav-link dropdown-toggle"
                href="#partnershipOpportunity"
                role="button"
                data-bs-toggle="collapse"
                aria-expanded="false"
                aria-controls="partnershipOpportunity"
              >
                {menu4("m41.title")}
              </a>

              <div
                id="partnershipOpportunity"
                className="nav-collapse collapse "
              >
                <Link className="nav-link" to="/dashboard/company">
                  {menu4("m41.m411")}
                </Link>
                <Link className="nav-link" to="/dashboard/company">
                  {menu4("m41.m421")}
                </Link>
              </div>
            </div>
            <div id="partnership" className="nav-collapse collapse ">
              <a
                className="nav-link dropdown-toggle"
                href="#partnershipManagement"
                role="button"
                data-bs-toggle="collapse"
                aria-expanded="false"
                aria-controls="partnershipManagement"
              >
                {menu4("m42.title")}
              </a>

              <div
                id="partnershipManagement"
                className="nav-collapse collapse "
              >
                <Link className="nav-link" to="/dashboard/company">
                  {menu4("m42.m421")}
                </Link>
                <Link className="nav-link" to="/dashboard/company">
                  {menu4("m42.m422")}
                </Link>
              </div>
            </div>
          </li>
          <li className="nav-item ">
            <a
              className="nav-link dropdown-toggle"
              href="#opportunities"
              role="button"
              data-bs-toggle="collapse"
              aria-expanded="false"
              aria-controls="opportunities"
            >
              {menu5("title")}
            </a>

            <div id="opportunities" className="nav-collapse collapse ">
              <a
                className="nav-link dropdown-toggle"
                href="#tender"
                role="button"
                data-bs-toggle="collapse"
                aria-expanded="false"
                aria-controls="tender"
              >
                {menu5("m51.title")}
              </a>

              <div id="tender" className="nav-collapse collapse ">
                <Link className="nav-link" to="/dashboard/company">
                  {menu5("m51.m511")}
                </Link>
                <Link className="nav-link" to="/dashboard/company">
                  {menu5("m51.m512")}
                </Link>
              </div>
            </div>
            <div id="opportunities" className="nav-collapse collapse ">
              <a
                className="nav-link dropdown-toggle"
                href="#fundingProject"
                role="button"
                data-bs-toggle="collapse"
                aria-expanded="false"
                aria-controls="fundingProject"
              >
                {menu5("m52.title")}
              </a>

              <div id="fundingProject" className="nav-collapse collapse ">
                <Link className="nav-link" to="/dashboard/company">
                  {menu5("m52.m521")}
                </Link>
                <Link className="nav-link" to="/dashboard/company">
                  {menu5("m52.m522")}
                </Link>
              </div>
            </div>
            <div id="opportunities" className="nav-collapse collapse ">
              <a
                className="nav-link dropdown-toggle"
                href="#event"
                role="button"
                data-bs-toggle="collapse"
                aria-expanded="false"
                aria-controls="event"
              >
                {menu5("m53.title")}
              </a>

              <div id="event" className="nav-collapse collapse ">
                <Link className="nav-link" to="/dashboard/company">
                  {menu5("m53.m531")}
                </Link>
                <Link className="nav-link" to="/dashboard/company">
                  {menu5("m53.m532")}
                </Link>
                <Link className="nav-link" to="/dashboard/company">
                  {menu5("m53.m533")}
                </Link>
              </div>
            </div>
          </li>

          <li className="nav-item ">
            <Link to="/dashboard/communication" className="nav-link">
              {menu("m6")}
            </Link>
          </li>
          <li className="nav-item ">
            <a
              className="nav-link dropdown-toggle"
              href="#ressources"
              role="button"
              data-bs-toggle="collapse"
              aria-expanded="false"
              aria-controls="ressources"
            >
              {menu7("title")}
            </a>

            <div id="ressources" className="nav-collapse collapse ">
              <a
                className="nav-link dropdown-toggle"
                href="#tender"
                role="button"
                data-bs-toggle="collapse"
                aria-expanded="false"
                aria-controls="tender"
              >
                {menu7("m71.title")}
              </a>

              <div id="tender" className="nav-collapse collapse ">
                <Link className="nav-link" to="/dashboard/company">
                  {menu7("m71.m711")}
                </Link>
                <Link className="nav-link" to="/dashboard/company">
                  {menu7("m71.m712")}
                </Link>
                <Link className="nav-link" to="/dashboard/company">
                  {menu7("m71.m713")}
                </Link>
              </div>
            </div>
            <div id="ressources" className="nav-collapse collapse ">
              <a
                className="nav-link dropdown-toggle"
                href="#conferences"
                role="button"
                data-bs-toggle="collapse"
                aria-expanded="false"
                aria-controls="conferences"
              >
                {menu7("m72.title")}
              </a>

              <div id="conferences" className="nav-collapse collapse ">
                <Link className="nav-link" to="/dashboard/company">
                  {menu7("m72.m721")}
                </Link>
              </div>
            </div>
            <div id="ressources" className="nav-collapse collapse ">
              <a
                className="nav-link dropdown-toggle"
                href="#tools"
                role="button"
                data-bs-toggle="collapse"
                aria-expanded="false"
                aria-controls="tools"
              >
                {menu7("m73.title")}
              </a>

              <div id="tools" className="nav-collapse collapse ">
                <Link className="nav-link" to="/dashboard/company">
                  {menu7("m73.m731")}
                </Link>
                <Link className="nav-link" to="/dashboard/company">
                  {menu7("m73.m732")}
                </Link>
                <Link className="nav-link" to="/dashboard/company">
                  {menu7("m73.m733")}
                </Link>
              </div>
            </div>
          </li>
        </>
      )}

      {/* SETTINGS */}
      <li className="nav-item ">
        <a
          className="nav-link dropdown-toggle"
          href="#settings"
          role="button"
          data-bs-toggle="collapse"
          aria-expanded="false"
          aria-controls="settings"
        >
          {menu8("title")}
        </a>

        <div id="settings" className="nav-collapse collapse ">
          <a
            className="nav-link dropdown-toggle"
            href="#preferences"
            role="button"
            data-bs-toggle="collapse"
            aria-expanded="false"
            aria-controls="tender"
          >
            {menu8("m81.title")}
          </a>

          <div id="preferences" className="nav-collapse collapse ">
            <Link className="nav-link" to="/dashboard/company">
              {menu8("m81.m811")}
            </Link>
            <Link className="nav-link" to="/dashboard/languages">
              {menu8("m81.m812")}
            </Link>
            <Link className="nav-link" to="/dashboard/company">
              {menu8("m81.m813")}
            </Link>
          </div>
        </div>
        <div id="settings" className="nav-collapse collapse ">
          <a
            className="nav-link dropdown-toggle"
            href="#security"
            role="button"
            data-bs-toggle="collapse"
            aria-expanded="false"
            aria-controls="security"
          >
            {menu8("m82.title")}
          </a>

          <div id="security" className="nav-collapse collapse ">
            <Link className="nav-link" to="/dashboard/company">
              {menu8("m82.m821")}
            </Link>
            <Link className="nav-link" to="/dashboard/company">
              {menu8("m82.m822")}
            </Link>
          </div>
        </div>
        <div id="settings" className="nav-collapse collapse ">
          <a
            className="nav-link dropdown-toggle"
            href="#invoiceSubscription"
            role="button"
            data-bs-toggle="collapse"
            aria-expanded="false"
            aria-controls="invoiceSubscription"
          >
            {menu8("m83.title")}
          </a>

          <div id="invoiceSubscription" className="nav-collapse collapse ">
            <Link className="nav-link" to="/dashboard/company">
              {menu8("m83.m831")}
            </Link>
            <Link className="nav-link" to="/dashboard/company">
              {menu8("m83.m832")}
            </Link>
          </div>
        </div>
      </li>
    </ul>
  );
};

export default Index;
